// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__113wy","title":"Info_title__qobOO","text":"Info_text__3IjL_"};